import React, { useState } from "react";
import "./Contact.css";
import "../Css/style.css";
import InputForm from "../Forms/InputForm";
import TextAreaForm from "../Forms/TextAreaForm";
import ButtonForm from "../Forms/ButtonForm";
import { useAppContext } from "../../contexts/AppContext";
import axios from "axios";
import parse from "html-react-parser";
function ContacForm() {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [comment, setComment] = useState("");
  const [message, setMessage] = useState("");
  const { backendUrl, translate } = useAppContext();
  const [images, setImages] = useState([]); // This stores the selected images
  const [imagePreviews, setImagePreviews] = useState([]);
  const tesimonialsListRoute = "/testimonialsList";

  // Handle image changes and validation
  const handleImageChange = (e) => {
    const files = e.target.files;
    const fileArray = Array.from(files); // Convert FileList to an array

    // Validate the images (only PNG or JPEG and less than 2 MB)
    const validImages = fileArray.filter((file) => {
      const isValidFormat =
        file.type === "image/png" || file.type === "image/jpeg";
      const isValidSize = file.size <= 2 * 1024 * 1024; // Less than 2 MB
      return isValidFormat && isValidSize;
    });

    if (validImages.length !== fileArray.length) {
      alert("Only PNG and JPEG images under 2MB are allowed.");
    }

    setImages(validImages);

    // Create previews of the selected images
    const previews = validImages.map((file) => URL.createObjectURL(file));
    setImagePreviews(previews);
  };

  // Handle the removal of selected images
  const handleImageDelete = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
    setImagePreviews((prevPreviews) =>
      prevPreviews.filter((_, i) => i !== index)
    );
  };

  const commentData = new FormData();
  commentData.append("name", fullName);
  commentData.append("email", email);
  commentData.append("comment", comment);
  images.forEach((image) => {
    commentData.append("images", image);
  });

  let headers = {};
  if (images.length > 0) {
    // If images exist, set Content-Type to multipart/form-data
    headers["Content-Type"] = "multipart/form-data";
  } else {
    // Otherwise, we can send as JSON (or without specific content type)
    headers["Content-Type"] = "application/json";
  }

  // Validate the email
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form
    if (!isValidEmail(email)) {
      alert("Please enter a valid email address.");
      return;
    }

    // Only validate image if it has been uploaded
    if (images.length > 0) {
      // Validate image format and size
      const validImages = images.filter((file) => {
        const isValidFormat =
          file.type === "image/png" || file.type === "image/jpeg";
        const isValidSize = file.size <= 2 * 1024 * 1024; // Less than 2 MB
        return isValidFormat && isValidSize;
      });

      if (validImages.length !== images.length) {
        alert("Only PNG and JPEG images under 2MB are allowed.");
        return;
      }
    }

    try {
      // Send the form data to the backend
      await axios.post(`${backendUrl}${tesimonialsListRoute}`, commentData, {
        headers,
      });

      setMessage("Thank you for your comment!");
      setComment("");
      setEmail("");
      setFullName("");
      setImagePreviews([]);
      setImages([]);

      // Clear the thank you message after 3 seconds
      setTimeout(() => {
        setMessage("");
      }, 3000);
    } catch (err) {
      console.error("Error submitting form:", err);
      alert("An error occurred while submitting the form.");
    }
  };

  return (
    <div className="contact-form padding-5 justify-center">
      <InputForm
        onchange={(e) => setFullName(e.target.value)}
        labelName={parse(translate("Full Name"))}
        inputType="text"
        value={fullName}
      />
      <InputForm
        onchange={(e) => setEmail(e.target.value)}
        labelName={parse(translate("Email"))}
        inputType="email"
        value={email}
      />

      <TextAreaForm
        onchange={(e) => setComment(e.target.value)}
        labelName={parse(translate("Comment"))}
        value={comment}
      />

      <div className="input-container">
        <label
          className="label m-1 px-3 py-1 rounded-2 primary-color "
          style={{ backgroundColor: "rgba(0,0,0,0.05)", cursor: "pointer" }}
        >
          {parse(translate("select your photo"))}
          <input
            type="file"
            className="file-inputs"
            multiple
            accept="image/*"
            onChange={handleImageChange}
          />
        </label>
        <span className="bi bi-image"></span>
      </div>

      <div className="image-previews d-flex flex-wrap">
        {imagePreviews.map((preview, index) => (
          <div
            key={index}
            className="image-preview-container position-relative m-2"
          >
            <img
              src={preview}
              alt={`Preview ${index + 1}`}
              className="image-preview"
              style={{ width: "120px", height: "120px", objectFit: "cover" }}
            />
            <button
              className="btn btn-danger position-absolute top-0 end-0"
              onClick={() => handleImageDelete(index)}
            >
              X
            </button>
          </div>
        ))}
      </div>

      <ButtonForm
        onclick={handleSubmit}
        buttonText={parse(translate("Submit"))}
        color="primary-button"
      />
      {message && (
        <label className="fw-bolder text-success">
          {parse(translate(message))}
        </label>
      )}
    </div>
  );
}

export default ContacForm;
